// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import axios from "axios";
// import Select from "react-select";
// import API_BASE_URL from "../../../src/config";

// const LocationTab = forwardRef(({ stayId: propStayId }, ref) => {
//   const [locations, setLocations] = useState([]);
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [address, setAddress] = useState("");

//   // Use stayId from props or fallback to localStorage
//   const stayId = propStayId || localStorage.getItem("stayId");

//   useEffect(() => {
//     const fetchLocations = async () => {
//       try {
//        // const res = await axios.get("http://localhost:3000/api/v1/home/locations");
//         const res = await axios.get(`${API_BASE_URL}home/locations`);
//         if (res.data.success) {
//           setLocations(res.data.data);
//           const defaultLoc = res.data.data.find(loc => loc.location_name === "West Bengal") || null;
//           setSelectedLocation(defaultLoc);
//         }
//       } catch (err) {
//         console.error("Error fetching locations:", err);
//       }
//     };
//     fetchLocations();
//   }, []);

//   // Expose submit function to parent
//   useImperativeHandle(ref, () => ({
//     submit: async () => {
//       if (!address) {
//         alert("Please enter address and select location.");
//         return;
//       }

//       if (!stayId) {
//         alert("Stay ID not found. Please complete Basic Info first.");
//         return;
//       }

//       try {
//         const token = localStorage.getItem("accessToken") || "";
//         const payload = {
//           stayId: stayId,
//           address: address, // address as entered by user
//           location: selectedLocation?.id,
//         };
//         const res = await axios.post(
//         //  "http://localhost:3000/api/v1/stays/update-stay",
//           `${API_BASE_URL}stays/update-stay`,
//           payload,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         alert("Location info saved successfully!");
//         console.log("Response:", res.data);
//       } catch (err) {
//         console.error("Error saving location info:", err);
//         alert("Failed to save location info.");
//       }
//     },
//   }));

//   return (
//     <div className="row">
//       <div className="col-12">
//         <div className="basicinfodltheadingouter">
//           <div className="dltheading">
//             <h2>Property Location Details</h2>
//             <p>Please fill in the location details of your property.</p>
//           </div>
//         </div>
//       </div>

//       {/* Left Side - Form */}
//       <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
//         <div className="infotext w-100 mt-0 mb-3">
//           <i className="icon icon-info"></i>
//           <span>Please enter the address.</span>
//         </div>

//         <div className="row gx-3 gx-lg-4">
//           {/* Address Input */}
//           <div className="col-12">
//             <div className="form-group">
//               <label>House/Building/Apartment No.</label>
//               <div className="formgroupinner">
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Search Here"
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                 />
//                 <button className="bssearchbtn" type="button">
//                   <i className="icon icon-search"></i>
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Location Select */}
//           <div className="col-12">
//             <div className="form-group">
//               <label>Location</label>
//               <div className="formgroupinner">
//                 <Select
//                   options={locations.map((loc) => ({
//                     value: loc.id,
//                     label: loc.location_name,
//                   }))}
//                   value={
//                     selectedLocation
//                       ? { value: selectedLocation.id, label: selectedLocation.location_name }
//                       : null
//                   }
//                   onChange={(option) =>
//                     setSelectedLocation({ id: option.value, location_name: option.label })
//                   }
//                   placeholder="Select or type a location"
//                   isSearchable
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Right Side - Map */}
//       <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
//         <div className="basicinfomap">
//           <iframe
//             src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d79610.84892734376!2d88.70996152408539!3d26.518969366882555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1759029914142!5m2!1sen!2sin"
//             width="600"
//             height="450"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//             referrerPolicy="no-referrer-when-downgrade"
//             title="property-location-map"
//           ></iframe>
//         </div>
//       </div>
//     </div>
//   );
// });

// export default LocationTab;

// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import axios from "axios";
// import Select from "react-select";
// import API_BASE_URL from "../../../src/config";

// const LocationTab = forwardRef(({ stayId: propStayId }, ref) => {
//   const [locations, setLocations] = useState([]);
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [address, setAddress] = useState("");

//   // Use stayId from props or fallback to localStorage
//   const stayId = propStayId || localStorage.getItem("stayId");

//   // Fetch locations for select dropdown
//   useEffect(() => {
//     const fetchLocations = async () => {
//       try {
//         const res = await axios.get(`${API_BASE_URL}home/locations`);
//         if (res.data.success) {
//           setLocations(res.data.data);

//           // Default location
//           const defaultLoc = res.data.data.find(loc => loc.location_name === "West Bengal") || null;
//           setSelectedLocation(defaultLoc);
//         }
//       } catch (err) {
//         console.error("Error fetching locations:", err);
//       }
//     };
//     fetchLocations();
//   }, []);

//   // Fetch stay details if stayId exists and pre-fill address & location
//   useEffect(() => {
//     if (!stayId) return;

//     const fetchStayDetails = async () => {
//       try {
//         const token = localStorage.getItem("accessToken") || "";
//         const res = await axios.post(
//           `${API_BASE_URL}stays/details`,
//           { id: stayId }, // <-- payload in body
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         if (res.data.success && res.data.data) {
//           const data = res.data.data;

//           setAddress(data.address || "");
//           if (data.Location) {
//             setSelectedLocation({
//               id: data.Location.id,
//               location_name: data.Location.location_name,
//             });
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching stay details:", err);
//       }
//     };

//     fetchStayDetails();
//   }, [stayId]);

//   // Expose submit function to parent
//   useImperativeHandle(ref, () => ({
//     submit: async () => {
//       if (!address || !selectedLocation) {
//         alert("Please enter address and select location.");
//         return;
//       }

//       if (!stayId) {
//         alert("Stay ID not found. Please complete Basic Info first.");
//         return;
//       }

//       try {
//         const token = localStorage.getItem("accessToken") || "";
//         const payload = {
//           stayId: stayId,
//           address: address,
//           location: selectedLocation.id,
//         };
//         const res = await axios.post(
//           `${API_BASE_URL}stays/update-stay`,
//           payload,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         alert("Location info saved successfully!");
//         console.log("Response:", res.data);
//       } catch (err) {
//         console.error("Error saving location info:", err);
//         alert("Failed to save location info.");
//       }
//     },
//   }));

//   return (
//     <div className="row">
//       <div className="col-12">
//         <div className="basicinfodltheadingouter">
//           <div className="dltheading">
//             <h2>Property Location Details</h2>
//             <p>Please fill in the location details of your property.</p>
//           </div>
//         </div>
//       </div>

//       {/* Left Side - Form */}
//       <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
//         <div className="infotext w-100 mt-0 mb-3">
//           <i className="icon icon-info"></i>
//           <span>Please enter the address.</span>
//         </div>

//         <div className="row gx-3 gx-lg-4">
//           {/* Address Input */}
//           <div className="col-12">
//             <div className="form-group">
//               <label>House/Building/Apartment No.</label>
//               <div className="formgroupinner">
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Search Here"
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                 />
//                 <button className="bssearchbtn" type="button">
//                   <i className="icon icon-search"></i>
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Location Select */}
//           <div className="col-12">
//             <div className="form-group">
//               <label>Location</label>
//               <div className="formgroupinner">
//                 <Select
//                   options={locations.map((loc) => ({
//                     value: loc.id,
//                     label: loc.location_name,
//                   }))}
//                   value={
//                     selectedLocation
//                       ? { value: selectedLocation.id, label: selectedLocation.location_name }
//                       : null
//                   }
//                   onChange={(option) =>
//                     setSelectedLocation({ id: option.value, location_name: option.label })
//                   }
//                   placeholder="Select or type a location"
//                   isSearchable
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Right Side - Map */}
//       <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
//         <div className="basicinfomap">
//           <iframe
//             src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d79610.84892734376!2d88.70996152408539!3d26.518969366882555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1759029914142!5m2!1sen!2sin"
//             width="600"
//             height="450"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//             referrerPolicy="no-referrer-when-downgrade"
//             title="property-location-map"
//           ></iframe>
//         </div>
//       </div>
//     </div>
//   );
// });

// export default LocationTab;


// commented Date 26/12/2025
// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import axios from "axios";
// import Select from "react-select";
// import { toast } from "react-toastify";
// import API_BASE_URL from "../../../src/config";

// // const LocationTab = forwardRef(({ stayId: propStayId }, ref) => {
// //   const [locations, setLocations] = useState([]);
// //   const [selectedLocation, setSelectedLocation] = useState(null);
// //   const [address, setAddress] = useState("");

// //   // Use stayId from props or fallback to localStorage
// //   const stayId = propStayId || localStorage.getItem("stayId");

// //   // Fetch locations for select dropdown
// //   useEffect(() => {
// //     const fetchLocations = async () => {
// //       try {
// //         const res = await axios.get(`${API_BASE_URL}home/locations`);
// //         if (res.data.success) {
// //           setLocations(res.data.data);

// //           // Default location
// //           const defaultLoc = res.data.data.find(loc => loc.location_name === "West Bengal") || null;
// //           setSelectedLocation(defaultLoc);
// //         }
// //       } catch (err) {
// //         console.error("Error fetching locations:", err);
// //       }
// //     };
// //     fetchLocations();
// //   }, []);

// //   // Fetch stay details if stayId exists and pre-fill address & location
// //   useEffect(() => {
// //     if (!stayId) return;

// //     const fetchStayDetails = async () => {
// //       try {
// //         const token = localStorage.getItem("accessToken") || "";
// //         const res = await axios.post(
// //           `${API_BASE_URL}stays/details`,
// //           { id: stayId }, // <-- payload in body
// //           { headers: { Authorization: `Bearer ${token}` } }
// //         );

// //         if (res.data.success && res.data.data) {
// //           const data = res.data.data;

// //           setAddress(data.address || "");
// //           if (data.Location) {
// //             setSelectedLocation({
// //               id: data.Location.id,
// //               location_name: data.Location.location_name,
// //             });
// //           }
// //         }
// //       } catch (err) {
// //         console.error("Error fetching stay details:", err);
// //       }
// //     };

// //     fetchStayDetails();
// //   }, [stayId]);

// //   // Expose submit function to parent
// //   useImperativeHandle(ref, () => ({
// //     submit: async () => {
// //       if (!address || !selectedLocation) {
// //         alert("Please enter address and select location.");
// //         return;
// //       }

// //       if (!stayId) {
// //         alert("Stay ID not found. Please complete Basic Info first.");
// //         return;
// //       }

// //       try {
// //         const token = localStorage.getItem("accessToken") || "";
// //         const payload = {
// //           stayId: stayId,
// //           address: address,
// //           location: selectedLocation.id,
// //         };
// //         const res = await axios.post(
// //           `${API_BASE_URL}stays/update-stay`,
// //           payload,
// //           { headers: { Authorization: `Bearer ${token}` } }
// //         );
// //         alert("Location info saved successfully!");
// //         console.log("Response:", res.data);
// //       } catch (err) {
// //         console.error("Error saving location info:", err);
// //         alert("Failed to save location info.");
// //       }
// //     },
// //   }));

// //   return (
// //     <div className="row">
// //       <div className="col-12">
// //         <div className="basicinfodltheadingouter">
// //           <div className="dltheading">
// //             <h2>Property Location Details</h2>
// //             <p>Please fill in the location details of your property.</p>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Left Side - Form */}
// //       <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
// //         <div className="infotext w-100 mt-0 mb-3">
// //           <i className="icon icon-info"></i>
// //           <span>Please enter the address.</span>
// //         </div>

// //         <div className="row gx-3 gx-lg-4">
// //           {/* Address Input */}
// //           <div className="col-12">
// //             <div className="form-group">
// //               <label>House/Building/Apartment No.</label>
// //               <div className="formgroupinner">
// //                 <input
// //                   type="text"
// //                   className="form-control"
// //                   placeholder="Search Here"
// //                   value={address}
// //                   onChange={(e) => setAddress(e.target.value)}
// //                 />
// //                 <button className="bssearchbtn" type="button">
// //                   <i className="icon icon-search"></i>
// //                 </button>
// //               </div>
// //             </div>
// //           </div>

// //           {/* Location Select */}
// //           <div className="col-12">
// //             <div className="form-group">
// //               <label>Location</label>
// //               <div className="formgroupinner">
// //                 <Select
// //                   options={locations.map((loc) => ({
// //                     value: loc.id,
// //                     label: loc.location_name,
// //                   }))}
// //                   value={
// //                     selectedLocation
// //                       ? { value: selectedLocation.id, label: selectedLocation.location_name }
// //                       : null
// //                   }
// //                   onChange={(option) =>
// //                     setSelectedLocation({ id: option.value, location_name: option.label })
// //                   }
// //                   placeholder="Select or type a location"
// //                   isSearchable
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Right Side - Map */}
// //       <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
// //         <div className="basicinfomap">
// //           <iframe
// //             src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d79610.84892734376!2d88.70996152408539!3d26.518969366882555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1759029914142!5m2!1sen!2sin"
// //             width="600"
// //             height="450"
// //             style={{ border: 0 }}
// //             allowFullScreen=""
// //             loading="lazy"
// //             referrerPolicy="no-referrer-when-downgrade"
// //             title="property-location-map"
// //           ></iframe>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // });

// const LocationTab = forwardRef(({ stayId: propStayId }, ref) => {
//   const [locations, setLocations] = useState([]);
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [address, setAddress] = useState("");
//   const [loading, setLoading] = useState(false);

//   // Use stayId from props or fallback to localStorage
//   const stayId = propStayId || localStorage.getItem("stayId");

//   //. Fetch locations for select dropdown
//   useEffect(() => {
//     const fetchLocations = async () => {
//       try {
//         const res = await axios.get(`${API_BASE_URL}home/locations`);
//         if (res.data.success) {
//           setLocations(res.data.data);

//           // Default location (optional)
//           const defaultLoc =
//             res.data.data.find((loc) => loc.location_name === "West Bengal") ||
//             null;
//           setSelectedLocation(defaultLoc);
//         }
//       } catch (err) {
//         console.error("Error fetching locations:", err);
//         toast.error("Failed to load location list.");
//       }
//     };
//     fetchLocations();
//   }, []);

//   //. Fetch stay details if stayId exists and pre-fill
//   useEffect(() => {
//     if (!stayId) return;

//     const fetchStayDetails = async () => {
//       try {
//         const token = localStorage.getItem("accessToken") || "";
//         const res = await axios.post(
//           `${API_BASE_URL}stays/details`,
//           { id: stayId },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         if (res.data.success && res.data.data) {
//           const data = res.data.data;
//           setAddress(data.address || "");
//           if (data.Location) {
//             setSelectedLocation({
//               id: data.Location.id,
//               location_name: data.Location.location_name,
//             });
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching stay details:", err);
//         toast.error("Failed to load stay details.");
//       }
//     };

//     fetchStayDetails();
//   }, [stayId]);

//   //. Validation helper
//   const validateForm = () => {
//     if (!address.trim()) {
//       toast.warn("Please enter your property address.");
//       return false;
//     }
//     if (!selectedLocation) {
//       toast.warn("Please select a location.");
//       return false;
//     }
//     if (!stayId) {
//       toast.warn("Stay ID not found. Please complete Basic Info first.");
//       return false;
//     }
//     return true;
//   };

//   //. Expose submit() to parent
//   useImperativeHandle(ref, () => ({
//     submit: async () => {
//       if (!validateForm()) return false;

//       try {
//         setLoading(true);
//         const token = localStorage.getItem("accessToken") || "";
//         const payload = {
//           stayId,
//           address,
//           location: selectedLocation.id,
//         };
//         const res = await axios.post(
//           `${API_BASE_URL}stays/update-stay`,
//           payload,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         if (res.data.success) {
//           toast.success("Location info saved successfully!");
//           return true;
//         } else {
//           toast.error("Failed to save location info.");
//           return false;
//         }
//       } catch (err) {
//         console.error("Error saving location info:", err);
//         toast.error("An error occurred while saving location info.");
//         return false;
//       } finally {
//         setLoading(false);
//       }
//     },
//   }));

//   return (
//     <div className="row">
//       <div className="col-12">
//         <div className="basicinfodltheadingouter">
//           <div className="dltheading">
//             <h2>Property Location Details</h2>
//             <p>Please fill in the location details of your property.</p>
//           </div>
//         </div>
//       </div>

//       {/* Left Side - Form */}
//       <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
//         <div className="infotext w-100 mt-0 mb-3">
//           <i className="icon icon-info"></i>
//           <span>Please enter the address.</span>
//         </div>

//         <div className="row gx-3 gx-lg-4">
//           {/* Address Input */}
//           <div className="col-12">
//             <div className="form-group">
//               <label>House/Building/Apartment No.</label>
//               <div className="formgroupinner">
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Enter address"
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                   disabled={loading}
//                 />
//                 {/* <button className="bssearchbtn" type="button">
//                   <i className="icon icon-search"></i>
//                 </button> */}
//               </div>
//             </div>
//           </div>

//           {/* Location Select */}
//           <div className="col-12">
//             <div className="form-group">
//               <label>Location</label>
//               <div className="formgroupinner">
//                 <Select
//                   options={locations.map((loc) => ({
//                     value: loc.id,
//                     label: loc.location_name,
//                   }))}
//                   value={
//                     selectedLocation
//                       ? {
//                           value: selectedLocation.id,
//                           label: selectedLocation.location_name,
//                         }
//                       : null
//                   }
//                   onChange={(option) =>
//                     setSelectedLocation({
//                       id: option.value,
//                       location_name: option.label,
//                     })
//                   }
//                   placeholder="Select or type a location"
//                   isSearchable
//                   isDisabled={loading}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Right Side - Map */}
//       <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
//         <div className="basicinfomap">
//           <iframe
//             src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d79610.84892734376!2d88.70996152408539!3d26.518969366882555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1759029914142!5m2!1sen!2sin"
//             width="600"
//             height="450"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//             referrerPolicy="no-referrer-when-downgrade"
//             title="property-location-map"
//           ></iframe>
//         </div>
//       </div>
//     </div>
//   );
// });


// export default LocationTab;






import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle
} from "react";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import API_BASE_URL from "../../../src/config";

import {
  GoogleMap,
  Marker,
  useLoadScript
} from "@react-google-maps/api";

import Autocomplete from "react-google-autocomplete";

const libraries = ["places"];

const LocationTab = forwardRef(({ stayId: propStayId }, ref) => {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [address, setAddress] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [landmark, setLandmark] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [directionsToReach, setDirectionsToReach] = useState("");
  const [latLng, setLatLng] = useState({ lat: 26.5189, lng: 88.7196 });
  const [loading, setLoading] = useState(false);

  const stayId = propStayId || localStorage.getItem("stayId");

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    libraries
  });

  /* Fetch locations */
  useEffect(() => {
    axios.get(`${API_BASE_URL}home/locations`).then((res) => {
      if (res.data.success) {
        setLocations(res.data.data);
      }
    });
  }, []);

  /* Fetch stay details */
  useEffect(() => {
    if (!stayId) return;

    const token = localStorage.getItem("accessToken") || "";
    axios
      .post(
        `${API_BASE_URL}stays/details`,
        { id: stayId },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (res.data.success && res.data.data) {
          const d = res.data.data;
          setAddress(d.address || "");
          // Existing properties only have the old single-blob address and no
          // structured fields yet — default Line 1 to that raw text so the
          // form isn't confusingly blank, rather than silently splitting or
          // guessing at it. Nothing is written back until the owner Saves.
          setAddressLine1(d.address_line1 || d.address || "");
          setAddressLine2(d.address_line2 || "");
          setLandmark(d.landmark || "");
          setCity(d.city || "");
          setState(d.state || "");
          setZipcode(d.pincode || "");
          setDirectionsToReach(d.directions_to_reach || "");
          setLatLng({
            lat: Number(d.latitude) || 26.5189,
            lng: Number(d.longitude) || 88.7196
          });

          if (d.Location) {
            setSelectedLocation({
              id: d.Location.id,
              location_name: d.Location.location_name
            });
          }
        }
      });
  }, [stayId]);

  /* 🔥 Match Google place with dropdown, and pre-fill structured fields.
     Google's parsing is genuinely unreliable for rural NE India addresses —
     this is a best-effort pre-fill only. Every field it touches stays fully
     editable afterward, so a sparse/wrong Google result never blocks the
     owner from just typing the correct thing themselves. */
  const matchLocationFromPlace = (place) => {
    if (!place.address_components) return;

    let streetNumber = "";
    let route = "";
    let cityFromPlace = "";
    let stateFromPlace = "";
    let zipFromPlace = "";

    place.address_components.forEach((comp) => {
      if (comp.types.includes("street_number")) streetNumber = comp.long_name;
      if (comp.types.includes("route")) route = comp.long_name;
      if (comp.types.includes("locality")) cityFromPlace = comp.long_name;
      if (comp.types.includes("administrative_area_level_1")) stateFromPlace = comp.long_name;
      if (comp.types.includes("postal_code")) zipFromPlace = comp.long_name;
    });

    const line1 = [streetNumber, route].filter(Boolean).join(" ");
    if (line1) setAddressLine1(line1);
    if (cityFromPlace) setCity(cityFromPlace);
    if (stateFromPlace) setState(stateFromPlace);
    if (zipFromPlace) setZipcode(zipFromPlace);

    // Try to match with API locations
    const matched = locations.find((loc) =>
      loc.location_name.toLowerCase().includes(cityFromPlace.toLowerCase()) ||
      loc.location_name.toLowerCase().includes(stateFromPlace.toLowerCase())
    );

    if (matched) {
      setSelectedLocation({
        id: matched.id,
        location_name: matched.location_name
      });
    }
  };

  /* Validation */
  const validateForm = () => {
    if (!addressLine1) {
      toast.warn("Please enter Address Line 1");
      return false;
    }
    if (!city) {
      toast.warn("Please enter City");
      return false;
    }
    if (!selectedLocation) {
      toast.warn("Please select Homestay Area");
      return false;
    }
    return true;
  };

  /* Expose submit */
  useImperativeHandle(ref, () => ({
    submit: async () => {
      if (!validateForm()) return false;

      try {
        setLoading(true);
        const token = localStorage.getItem("accessToken") || "";
        const payload = {
          stayId,
          address_line1: addressLine1,
          address_line2: addressLine2,
          landmark,
          city,
          state,
          pincode: zipcode,
          directions_to_reach: directionsToReach,
          location: selectedLocation.id,
          latitude: latLng.lat,
          longitude: latLng.lng
        };

        const res = await axios.post(
          `${API_BASE_URL}stays/update-stay`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.success) {
          toast.success("Location saved successfully");
          return true;
        }
        return false;
      } catch (err) {
        toast.error("Failed to save location");
        return false;
      } finally {
        setLoading(false);
      }
    }
  }));

  if (!isLoaded) return <p>Loading map...</p>;

  return (
    <div className="row">
      {/* Left */}
      <div className="col-md-6">
        <div className="form-group">
          <label>Search Address (optional)</label>
          <Autocomplete
            apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}
            onPlaceSelected={(place) => {
              if (place.geometry && place.geometry.location) {
                setLatLng({
                  lat: place.geometry.location.lat(),
                  lng: place.geometry.location.lng()
                });
              }
              // Best-effort pre-fill only — every field below stays editable,
              // since Google's parsing is unreliable for rural NE India addresses.
              matchLocationFromPlace(place);
            }}
            options={{
              types: ["geocode"],
              componentRestrictions: { country: "in" }
            }}
            className="form-control"
            placeholder="Search to auto-fill the fields below, or fill them in yourself"
          />
          <small className="form-text text-muted">
            This just helps pre-fill the fields below — enter or correct anything Google gets wrong.
          </small>
        </div>

        <div className="form-group mt-3">
          <label>Address Line 1</label>
          <input
            type="text"
            className="form-control"
            placeholder="House/building no., street"
            value={addressLine1}
            onChange={(e) => setAddressLine1(e.target.value)}
          />
        </div>

        <div className="form-group mt-3">
          <label>Address Line 2</label>
          <input
            type="text"
            className="form-control"
            placeholder="Area, village (optional)"
            value={addressLine2}
            onChange={(e) => setAddressLine2(e.target.value)}
          />
        </div>

        <div className="form-group mt-3">
          <label>Landmark</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Near ABC Petrol Pump (optional)"
            value={landmark}
            onChange={(e) => setLandmark(e.target.value)}
          />
        </div>

        <div className="form-group mt-3">
          <label>City</label>
          <input
            type="text"
            className="form-control"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </div>

        <div className="form-group mt-3">
          <label>State</label>
          <input
            type="text"
            className="form-control"
            value={state}
            onChange={(e) => setState(e.target.value)}
          />
        </div>

        <div className="form-group mt-3">
          <label>Zipcode</label>
          <input
            type="text"
            className="form-control"
            value={zipcode}
            onChange={(e) => setZipcode(e.target.value)}
          />
        </div>

        <div className="form-group mt-3">
          <label>Homestay Area</label>
          <Select
            options={locations.map((l) => ({
              value: l.id,
              label: l.location_name
            }))}
            value={
              selectedLocation
                ? {
                    value: selectedLocation.id,
                    label: selectedLocation.location_name
                  }
                : null
            }
            onChange={(opt) =>
              setSelectedLocation({
                id: opt.value,
                location_name: opt.label
              })
            }
            styles={{ menu: (base) => ({ ...base, zIndex: 20 }) }}
          />
        </div>

        <div className="form-group mt-3">
          <label>Best way to reach the property</label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="e.g. Last 2 km is a narrow unpaved road, cars should park at the village entrance and call for a pickup (optional)"
            value={directionsToReach}
            onChange={(e) => setDirectionsToReach(e.target.value)}
          />
        </div>
      </div>

      {/* Right */}
      <div className="col-md-6">
        <GoogleMap
          zoom={15}
          center={latLng}
          mapContainerStyle={{ width: "100%", height: "400px" }}
        >
          <Marker
            position={latLng}
            draggable
            onDragEnd={(e) => {
              setLatLng({ lat: e.latLng.lat(), lng: e.latLng.lng() });
            }}
          />
        </GoogleMap>
        <small className="form-text text-muted">
          Drag the pin to correct the exact location if the map isn't quite right.
        </small>
      </div>
    </div>
  );
});

export default LocationTab;